import React from 'react';

function Footer() {
  return <footer>Contato: (15) 99147-4614</footer>;
}

export default Footer;
